<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import axios from "axios";
import { VueLoading } from "vue-loading-template";

export default {
    components: { Layout, PageHeader, VueLoading },

    data() {
        return {
            month: '',
            type: 'order',
            ExtractList: [
                { value: "order", text: "抽出結果１（オーダー）" },
                { value: "set", text: "抽出結果２（セット）" },
                { value: "item", text: "抽出結果３（アイテム）" },
            ]
        }
    },
    validations: {},
    mounted() {
        this.getUser("users");
    },
    methods: {
        async exportExcel() {
            try {
                const response = await axios.post('/export', {
                    month: this.month.replace('-', ''),
                    type: this.type
                }, { responseType: 'blob' });

                // Laravelからのレスポンスヘッダからファイル名を取得
                const contentDisposition = response.headers['content-disposition'];
                let filename = 'export.xlsx';  // デフォルトのファイル名
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename\*=UTF-8''(.+)/);
                    if (match) {
                        filename = decodeURIComponent(match[1]);
                    } else {
                        // filenameを通常の形式でも取得
                        const matchFallback = contentDisposition.match(/filename="(.+)"/);
                        if (matchFallback) {
                            filename = matchFallback[1];
                        }
                    }
                }

                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            } catch (error) {
                console.error("Excel出力エラー:", error);
            }
        }
    }
}
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <form @submit.prevent="exportExcel">
                            <div class="row mt-2">
                                <div class="col-sm-12 col-md-3">
                                    <b-form-group label="対象月" label-for="month" label-cols-sm="4" label-cols-lg="4">
                                        <b-form-input id="month" v-model="month" class="form-control" type="month"
                                            required></b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-sm-12 col-md-3"></div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-sm-12  col-md-3">
                                    <b-form-group label="抽出条件" label-for="select" label-cols-sm="4" label-cols-lg="4">
                                        <b-form-select for="select" v-model="type" class="form-select"
                                            :options="ExtractList">
                                        </b-form-select>
                                    </b-form-group>
                                </div>
                                <div class="col-sm-12 col-md-3"></div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-sm-12 col-md-12">
                                    <div id="tickets-table_filter" class="text-md-end">
                                        <button class="btn btn-primary" type="submit">出力</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>


<style>
.minWidth100 {
    min-width: 100px;
}

.minWidth200 {
    min-width: 200px;
}

.minWidth300 {
    min-width: 300px;
}

.right {
    text-align: right;
}

.colorRed {
    color: red;
}

.table-hover tbody tr .colorRed {
    color: red;
}

.table-hover tbody tr:hover .colorRed {
    color: red;
}

.modal-mask {
    z-index: 10;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>